import type { LocaleLanguage } from './localeConfig';

export const translations: Record<string, Record<string, string>> = {
  en: {
    dashboard: 'Home',
    tenants: 'Companies',
    plans: 'Plans',
    settings: 'Settings',
    logout: 'Logout',
    search: 'Search',
    save: 'Save',
    cancel: 'Cancel',
    active: 'Active',
    inactive: 'Inactive',
    welcome: 'Welcome back',
    welcomeTo: 'Welcome to',
    signIn: 'Sign In',
    superAdmin: 'Super Admin',
    platformSettings: 'Platform Settings',
    language: 'Language',
    currency: 'Currency',
    timezone: 'Timezone',
    dateFormat: 'Date Format',
    country: 'Country',
    regionalSettings: 'Regional Settings',
    taxInvoice: 'Tax Invoice',
    billTo: 'Bill To',
    subscription: 'Subscription',
    description: 'Description',
    amount: 'Amount',
    discount: 'Discount',
    subtotal: 'Subtotal',
    gst: 'GST',
    total: 'Total',
    paymentMode: 'Payment Mode',
    invoiceDate: 'Invoice Date',
    dueDate: 'Due Date',
    paidOn: 'Paid On',
    billingPeriod: 'Billing Period',
    monthly: 'Monthly',
    yearly: 'Yearly',
    platformInvoiceNote: 'Platform subscription invoice — not a transport TMS invoice.',
    downloadPdf: 'Download PDF',
    printInvoice: 'Print',
  },
  hi: {
    dashboard: 'डैशबोर्ड',
    tenants: 'किरायेदार',
    plans: 'योजनाएं',
    settings: 'सेटिंग्स',
    logout: 'लॉग आउट',
    search: 'खोजें',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    active: 'सक्रिय',
    inactive: 'निष्क्रिय',
    welcome: 'वापसी पर स्वागत है',
    welcomeTo: 'स्वागत है',
    signIn: 'साइन इन',
    superAdmin: 'सुपर एडमिन',
    platformSettings: 'प्लेटफ़ॉर्म सेटिंग्स',
    language: 'भाषा',
    currency: 'मुद्रा',
    timezone: 'समय क्षेत्र',
    dateFormat: 'दिनांक प्रारूप',
    country: 'देश',
    regionalSettings: 'क्षेत्रीय सेटिंग्स',
    taxInvoice: 'कर इनवॉइस',
    billTo: 'बिल प्राप्तकर्ता',
    subscription: 'सदस्यता',
    description: 'विवरण',
    amount: 'राशि',
    discount: 'छूट',
    subtotal: 'उप-योग',
    gst: 'जीएसटी',
    total: 'कुल',
    paymentMode: 'भुगतान मोड',
    invoiceDate: 'इनवॉइस दिनांक',
    dueDate: 'देय दिनांक',
    paidOn: 'भुगतान दिनांक',
    billingPeriod: 'बिलिंग अवधि',
    monthly: 'मासिक',
    yearly: 'वार्षिक',
    platformInvoiceNote: 'प्लेटफ़ॉर्म सदस्यता इनवॉइस — परिवहन TMS इनवॉइस नहीं।',
    downloadPdf: 'PDF डाउनलोड',
    printInvoice: 'प्रिंट',
  },
};

export function translate(language: string, key: string): string {
  return translations[language]?.[key] || translations.en[key] || key;
}
